import { FileDTO } from './FileDTO'

export class ProfilePictureDTO
{
    ImageID_GUID:string
    ImageIDEncrypted:string
    FileName:string
    MediumPicture:string
    SmallPicture:string
    Original:string
    profilePicture:FileDTO
    AvatarPicture:FileDTO
    OriginalPicture:FileDTO
}